/**
 * Algolia SRP hits use Dynamo `objectID`. Typesense stores url-hash as `id` and optional `objectID`.
 */
export function resolveAlgoliaSearchHitObjectId(document: Record<string, unknown>): string {
  const objectID = String(document.objectID ?? '').trim();
  if (objectID) {
    return objectID;
  }
  return String(document.id ?? '').trim();
}
